import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';

const ND_LOGO = 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/b3n5tlbb_kling_20260128_Image_to_Video_create_int_3479_0.gif';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img src={ND_LOGO} alt="NAIWA Daughters logo" className="w-10 h-10 rounded-lg object-cover shadow-sm" data-testid="footer-logo-image" />
              <h3 className="font-bold text-lg !text-[#7E2F22]" style={{ color: '#7e2f22' }}>NAIWA Daughters</h3>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Empowering young Indigenous women through leadership, advocacy, and community engagement.
            </p>
            <div className="flex space-x-3 mt-4">
              <a
                href="https://www.facebook.com/naiwadaughterscherokee"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 hover:opacity-80"
                style={{ backgroundColor: '#53a5ca' }}
                aria-label="Facebook">

                <Facebook className="h-4 w-4 text-white" />
              </a>
              <a
                href="https://www.instagram.com/naiwadaughters/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 hover:opacity-80"
                style={{ backgroundColor: '#e37c55' }}
                aria-label="Instagram">

                <Instagram className="h-4 w-4 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4" style={{ color: '#7e2f22' }}>Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-600 hover:text-gray-900 transition-colors">About Us</Link></li>
              <li><Link to="/projects" className="text-gray-600 hover:text-gray-900 transition-colors">Our Projects</Link></li>
              <li><Link to="/impact" className="text-gray-600 hover:text-gray-900 transition-colors">Impact & Outcomes</Link></li>
              <li><Link to="/leadership" className="text-gray-600 hover:text-gray-900 transition-colors">Leadership Team</Link></li>
              <li><Link to="/events" className="text-gray-600 hover:text-gray-900 transition-colors">Events</Link></li>
              <li><Link to="/media" className="text-gray-600 hover:text-gray-900 transition-colors">Media & Blog</Link></li>
              <li><Link to="/login" className="text-gray-600 hover:text-gray-900 transition-colors" data-testid="footer-admin-portal-link">Admin Portal</Link></li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="font-semibold mb-4" style={{ color: '#7e2f22' }}>Get Involved</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/join" className="text-gray-600 hover:text-gray-900 transition-colors">Join Naiwa Daughters</Link></li>
              <li><Link to="/mentor" className="text-gray-600 hover:text-gray-900 transition-colors">Become a Mentor</Link></li>
              <li><Link to="/support" className="text-gray-600 hover:text-gray-900 transition-colors">Support Our Work</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4" style={{ color: '#7e2f22' }}>Contact</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: '#53a5ca' }} />
                <span>Cherokee, North Carolina</span>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: '#53a5ca' }} />
                <a href="mailto:info@naiwadaughters.org" className="hover:text-gray-900 transition-colors">naiwadaughters@gmail.com

                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: '#53a5ca' }} />
                <span>(865)202-8215</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} Naiwa Daughters. All rights reserved.</p>
          <p className="mt-2">First NAIWA Cherokee Chapter | Empowering Indigenous Young Women Since 2021</p>
        </div>
      </div>
    </footer>);

};

export default Footer;